import React from 'react';
import glamorous from 'glamorous';
import FaDollar from 'react-icons/lib/fa/dollar';

import Body from '../typography/Body';
import NumberField from '../ui/NumberField';
import TextField from '../ui/TextField';

import StickersheetRow from './StickersheetRow';

const colors = [
  'default',
  'white',
  'danger',
  'success',
];

const style = {
  marginRight: 8,
  marginBottom: 16,
};

const styleTitle = {
  marginBottom: 16,
  textTransform: 'capitalize',
};

const Row = glamorous.div({
  display: 'flex',
  flexWrap: 'wrap',
});

export default () => (
  <StickersheetRow title="TextFields">
    <div>
      <Body style={styleTitle}>Default</Body>
      <Row>
        {
          colors.map(color => (
            <TextField
              key={color}
              label="Field Label"
              placeholder={`${color.toUpperCase()} TextField`}
              color={color}
              style={style}
            />
          ))
        }
      </Row>
      <Row>
        {
          colors.map(color => (
            <TextField
              key={color}
              disabled
              label="Field Label"
              placeholder={`${color.toUpperCase()} Disabled`}
              color={color}
              style={style}
            />
          ))
        }
      </Row>
    </div>
    <div>
      <Body style={styleTitle}>Rounded</Body>
      <Row>
        {
          colors.map(color => (
            <TextField
              key={color}
              rounded
              label="Field Label"
              placeholder={`${color.toUpperCase()} Rounded`}
              color={color}
              style={style}
            />
          ))
        }
      </Row>
      <Row>
        {
          colors.map(color => (
            <TextField
              key={color}
              rounded
              disabled
              label="Field Label"
              placeholder={`${color.toUpperCase()} Disabled`}
              color={color}
              style={style}
            />
          ))
        }
      </Row>
    </div>
    <div>
      <Body style={styleTitle}>Large</Body>
      <Row>
        <TextField
          size="large"
          label="Field Label"
          placeholder="Large TextField"
          style={style}
        />
        <TextField
          rounded
          size="large"
          label="Field Label"
          placeholder="Large Rounded"
          style={style}
        />
      </Row>
    </div>
    <div>
      <Body style={styleTitle}>Numbers</Body>
      <Row>
        <NumberField
          placeholder="Min Price"
          leftIcon={<FaDollar size={16} />}
          style={style}
        />
        <NumberField
          leftIcon={<FaDollar size={16} />}
          placeholder="Max Price"
          style={style}
        />
      </Row>
    </div>
  </StickersheetRow>
);



// WEBPACK FOOTER //
// ./src/components/demo/TextFields.js